import { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";

const App = () => {
  const [isMobile, setIsMobile] = useState(true);

  useEffect(() => {
    const checkSize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    checkSize(); // run on load
    window.addEventListener("resize", checkSize);
    return () => window.removeEventListener("resize", checkSize);
  }, []);

  if (!isMobile) {
    return (
      <div
        style={{
          height: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <h3>This site is only available on mobile.</h3>
      </div>
    );
  }

  return (
    <div className="app">
      <header>
        <img id="logo" src="/Logo White.png" alt="BarlindBeer logo" />
        {/* <img src="/menu.svg" alt="menu icon" /> */}
      </header>
      <div className="brewery-img-wrapper">
        <img className="brewery-img" src="/brewery.png" alt="The brewery" />
      </div>
      <Outlet />

      <footer>
        <a href="https://barlindbeer.se/"> Visit BarlindBeer</a>
        <p>Built by Tyrus Consulting AB</p>
      </footer>
    </div>
  );
};

export default App;
